var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBackBtn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 8,
    fill: "#678DFF",
    fillOpacity: 0.16
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.08 34.08C28.4545 33.705 28.6649 33.1967 28.6649 32.6667C28.6649 32.1367 28.4545 31.6283 28.08 31.2533L20.8266 24L28.0799 16.7467C28.4332 16.3675 28.6256 15.8661 28.6164 15.3479C28.6073 14.8298 28.3974 14.3355 28.0309 13.969C27.6645 13.6026 27.1701 13.3927 26.652 13.3835C26.1339 13.3744 25.6324 13.5667 25.2533 13.92L16.5866 22.5867C16.2121 22.9617 16.0017 23.47 16.0017 24C16.0017 24.53 16.2121 25.0383 16.5866 25.4133L25.2533 34.08C25.6283 34.4545 26.1366 34.6649 26.6666 34.6649C27.1966 34.6649 27.7049 34.4545 28.08 34.08Z",
    fill: "#272727"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackBtn);
export default __webpack_public_path__ + "static/media/Back-btn.89526d6bff1adff4116a335ae3526a98.svg";
export { ForwardRef as ReactComponent };